import {
  createAdvert,
  deleteNewOfferFlag,
  getAdverts,
  markAsHidden,
  markAsRead,
  ongoingBidsSearch,
  updateAdvert,
  updateMinNettoWanted
} from '../../../services/adverts'

export default {
  getAdverts ({ commit }) {
    return new Promise((resolve, reject) => {
      getAdverts()
        .then(response => {
          const adverts = response.data
          commit('setAdverts', { adverts })
          resolve(adverts)
        })
        .catch(reject)
    })
  },

  ongoingBidsSearch ({ commit }) {
    return new Promise((resolve, reject) => {
      ongoingBidsSearch()
        .then(response => {
          const adverts = response.data
          commit('setOngoingBids', { adverts })
          resolve(adverts)
        })
        .catch(reject)
    })
  },

  createAdvert ({ commit }, { advert }) {
    return new Promise((resolve, reject) => {
      createAdvert(advert)
        .then(response => {
          const advert = response.data
          commit('createAdvert', { advert })
          resolve(advert)
        })
        .catch(reject)
    })
  },

  updateAdvert ({ commit }, { id, advert }) {
    return new Promise((resolve, reject) => {
      updateAdvert(id, advert)
        .then(response => {
          const newAdvert = response.data
          commit('updateAdvert', { newAdvert })
          resolve(newAdvert)
        })
        .catch(reject)
    })
  },

  markAdvertAsRead ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      markAsRead(id)
        .then(() => commit('markAdvertAsRead', { id }))
        .catch(reject)
    })
  },

  markAdvertAsHidden ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      markAsHidden(id)
        .then(() => commit('markAdvertAsHidden', { id }))
        .catch(reject)
    })
  },

  updateMinNettoWanted ({ commit }, { id, minNettoWanted }) {
    return new Promise((resolve, reject) => {
      updateMinNettoWanted(id, { minNettoWanted })
        .then(response => {
          commit('updateMinNettoWanted', { id, minNettoWanted })
          resolve(response)
        })
        .catch(reject)
    })
  },

  deleteNewOfferFlag ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      deleteNewOfferFlag(id)
        .then(response => {
          commit('deleteNewOfferFlag', { id })
          resolve(response)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adverts/actions.js